/*
 *
 * EkycPage reducer
 *
 */
import { createReducer } from '@reduxjs/toolkit';
import {
  CHANGE_AADHAAR_NUMBER,
  CHANGE_OTP_CODE,
  ADD_FORM_FIELD_ERROR,
  TOGGLE_CONSENT,
  FETCH_PUBLIC_KEY_REQUEST,
  FETCH_PUBLIC_KEY_SUCCESS,
  FETCH_PUBLIC_KEY_FAILURE,
  GENERATE_OTP_REQUEST,
  GENERATE_OTP_SUCCESS,
  GENERATE_OTP_FAILURE,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILURE,
  EKYC_STATUS_REQUEST,
  EKYC_STATUS_SUCCESS,
  EKYC_STATUS_FAILURE,
  EDIT_AADHAAR_NUMBER,
  REDIRECT_REQUEST,
  RESET_EKYC_FORM,
  UPDATE_KYC_ID,
  HANDLE_VID_MODAL,
} from './constants';
import { AUTH_FAILURE } from '../App/constants';

export const initialState = {
  // Form state
  form: {
    aadhaarNo: null,
    otpCode: null,
    consentChecked: true,
  },
  error: {},
  loading: null,
  loadingText: null,
  serverError: null,
  publicKey: null,
  otpGenerated: false,
  otpVerified: false,
  errorCode: null,
  kycId: null,
  kycType: null,
  vidModal: false
};

const ekycPageReducer = createReducer(initialState, (builder) => {
  builder
    // Form actions
    .addCase(CHANGE_AADHAAR_NUMBER, (state, action) => {
      state.form.aadhaarNo = action.value;
      state.error = {};
    })
    .addCase(CHANGE_OTP_CODE, (state, action) => {
      state.form.otpCode = action.value;
      state.error = {};
    })
    .addCase(ADD_FORM_FIELD_ERROR, (state, action) => {
      state.error[action.errorKey] = action.errorValue;
    })
    .addCase(TOGGLE_CONSENT, (state) => {
      state.form.consentChecked = !state.form.consentChecked;
      delete state.error.consent;
    })
    // Public Key
    .addCase(FETCH_PUBLIC_KEY_REQUEST, (state) => {
      state.loading = true;
    })
    .addCase(FETCH_PUBLIC_KEY_SUCCESS, (state, action) => {
      state.loading = false;
      state.publicKey = action.response.public_key;
    })
    .addCase(FETCH_PUBLIC_KEY_FAILURE, (state) => {
      state.loading = false;
      state.serverError = true;
    })
    // Generate OTP
    .addCase(GENERATE_OTP_REQUEST, (state) => {
      state.loadingText = 'kyc19';
      state.loading = true;
      state.error = {};
    })
    .addCase(GENERATE_OTP_SUCCESS, (state) => {
      state.loadingText = null;
      state.loading = false;
      state.otpGenerated = true;
    })
    .addCase(GENERATE_OTP_FAILURE, (state, action) => {
      state.loadingText = null;
      state.loading = false;
      if (action.error.error_code && action.error.error_code === 'ERROR_INVALID_AADHAAR') {
        state.error.aadhaarNo = 'kyc25';
      } else {
        state.serverError = true;
      }
    })
    // Verify OTP
    .addCase(VERIFY_OTP_REQUEST, (state) => {
      state.loadingText = 'kyc41';
      state.loading = true;
    })
    .addCase(VERIFY_OTP_SUCCESS, (state) => {
      state.loadingText = null;
      state.loading = false;
      state.otpVerified = true;
    })
    .addCase(VERIFY_OTP_FAILURE, (state, action) => {
      state.loadingText = null;
      state.loading = false;
      if (action.error.error_code && action.error.error_code === 'ERROR_INVALID_OTP') {
        state.error.otpCode = 'kyc24';
        state.form.otpCode = null;
      } else {
        state.serverError = true;
      }
    })
    // eKYC Status
    .addCase(EKYC_STATUS_REQUEST, (state) => {
      state.loading = true;
    })
    .addCase(EKYC_STATUS_SUCCESS, (state, action) => {
      state.loading = false;
      state.kycType = action.response.kyc_type;
    })
    .addCase(EKYC_STATUS_FAILURE, (state) => {
      state.loading = false;
      state.serverError = true;
    })
    // Redirect
    .addCase(REDIRECT_REQUEST, (state, action) => {
      state.loading = true;
      if (action.errorCode) {
        state.errorCode = action.errorCode;
      }
    })
    // Edit / Reset
    .addCase(EDIT_AADHAAR_NUMBER, (state) => {
      return {
        ...initialState,
        loadingText: 'kyc19',
        kycId: state.kycId,
        publicKey: state.publicKey,
        form: {
          ...initialState.form,
          aadhaarNo: state.form.aadhaarNo,
        },
      };
    })
    .addCase(RESET_EKYC_FORM, (state) => {
      state.error = {};
    })
    // KYC ID
    .addCase(UPDATE_KYC_ID, (state, action) => {
      state.kycId = action.kycId;
    })
    // VID Modal
    .addCase(HANDLE_VID_MODAL, (state, action) => {
      state.vidModal = action.open;
    })
    // Auth
    .addCase(AUTH_FAILURE, (state) => {
      state.loading = false;
    });
});

export default ekycPageReducer;
